import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faFilePen,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-hot-toast";
import axios from "axios";

import styles from "../../styles/locationStaff.module.css";
import search from "../../assets/images/search.png";
import { BASE_URL } from "../../utils/constants";
import { AddStaffModal, DeleteStaff, EditLocStaffModal } from "./staffModal";
import Table from "../../components/table";
import Button from "../../components/button-v1";
import { FaPlus } from "react-icons/fa";
import { handleApiError } from "../../utils/handleApiError";

const LocationStaff = () => {
  const [nameSearch, setNameSearch] = useState("");
  const [positionSearch, setPositionSearch] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(true);
  const [isAddStaffOpen, setIsAddStaffOpen] = useState(false);
  const [isEditStaffOpen, setIsEditStaffOpen] = useState(false);
  const [isDeleteStaffModalOpen, setIsDeleteStaffModalOpen] = useState(false);
  const [reMountStaff, setreMountStaff] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);

  useEffect(() => {
    const fetchStaffList = async () => {
      setStaffLoading(true);
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const location_id = JSON.parse(sessionStorage.getItem("current_loc")).id;
      const url = `${BASE_URL}/accounts/${account_id}/${location_id}/staff-list/?status=active`;

      if (location_id) {
        try {
          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          setStaffList(
            response.data.staff.filter(
              (staff) => staff.account_role?.name !== "Super User"
            )
          );
          setStaffLoading(false);
        } catch (error) {
          handleApiError(error);
        }
      } else {
        setStaffLoading(false);
        toast.error("No Active Location Found.");
      }
    };

    fetchStaffList();
  }, [reMountStaff]);

  // Add Staff modal functions
  const openAddStaffModal = () => {
    setIsAddStaffOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeAddStaffModal = () => {
    setIsAddStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Edit Staff modal functions
  const openEditStaffModal = (id) => {
    setCurrentStaffId(id);
    setIsEditStaffOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeEditStaffModal = () => {
    setIsEditStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Delete staff modal functions
  const openDeleteStaffModal = (id) => {
    setCurrentStaffId(id);
    setIsDeleteStaffModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeDeleteStaffModal = () => {
    setIsDeleteStaffModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const filteredData = staffList.filter((row) => {
    const fullName =
      `${row.user.first_name} ${row.user.last_name}`.toLowerCase();
    const matchesName = fullName.includes(nameSearch.toLowerCase());
    const matchesPosition = row?.account_position?.title
      .toLowerCase()
      .includes(positionSearch.toLowerCase());
    return matchesName && matchesPosition;
  });

  const staffTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: (row) => `${row.user.first_name} ${row.user.last_name}`,
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
      render: (row) => row.user.email,
    },
    {
      key: "position",
      label: "Position",
      render: (row) => row.account_position.title,
    },
    {
      key: "patients",
      label: "Patients",
      render: (row) =>
        row.account_role?.name === "Account Admin"
          ? "ALL"
          : row.assigned_patients_count,
      // ? row.account_role.name === "Account Admin" && "All"
      // : row.assigned_patients_count,
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: (row) => (
        <div className={styles.action_btns}>
          <Button variant="ghost" onClick={() => openEditStaffModal(row.id)}>
            <FontAwesomeIcon icon={faFilePen} />
          </Button>
          <Button variant="ghost" onClick={() => openDeleteStaffModal(row.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.staff_page}>
      <div className={styles.staff_page_container}>
        <div className={styles.patient_wrapper}>
          <div className={styles.top}>
            <p className={styles.heading}>
              Staff{" "}
              <small className={styles.counts}>({staffList.length})</small>
            </p>
            <div className={styles.top_left}>
              <Button onClick={openAddStaffModal}>
                <FaPlus size="10px" /> Add Staff
              </Button>
            </div>

            {isAddStaffOpen && (
              <AddStaffModal
                isOpen={isAddStaffOpen}
                onClose={closeAddStaffModal}
                comp_renderer={setreMountStaff}
                current_render={reMountStaff}
              />
            )}
          </div>

          <div className={styles.table_container}>
            <div className={styles.searchbar_container}>
              <div className={styles.input_wrapper}>
                <input
                  type="text"
                  placeholder="Search by Name"
                  value={nameSearch}
                  onChange={(e) => setNameSearch(e.target.value)}
                />
                <img alt=" " src={search} />
              </div>

              <div className={styles.input_wrapper}>
                <input
                  type="text"
                  placeholder="Search by Position"
                  value={positionSearch}
                  onChange={(e) => setPositionSearch(e.target.value)}
                />
                <img alt=" " src={search} />
              </div>
            </div>

            <div className={styles.all_patients}>
              <Table
                columns={staffTableColumns}
                data={filteredData}
                height={500}
                loading={staffLoading}
              />

              {isEditStaffOpen && (
                <EditLocStaffModal
                  isOpen={isEditStaffOpen}
                  onClose={closeEditStaffModal}
                  staff_info={
                    staffList
                      ? [...staffList].find(
                          (staff) => staff.id === currentStaffId
                        )
                      : {}
                  }
                  comp_renderer={setreMountStaff}
                  current_render={reMountStaff}
                />
              )}

              {isDeleteStaffModalOpen && (
                <DeleteStaff
                  isOpen={isDeleteStaffModalOpen}
                  onClose={closeDeleteStaffModal}
                  staff_info={
                    staffList
                      ? [...staffList].find(
                          (staff) => staff.id === currentStaffId
                        )
                      : {}
                  }
                  comp_renderer={setreMountStaff}
                  current_render={reMountStaff}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationStaff;
